import React from "react";
import { PathName } from "routers/types";
import { useLocation } from "react-router-dom";
import FilterFormMobile from "./FilterFormMobile";

const PAGES_REAL_ESTATE: PathName[] = [
  "/home-2",
  "/listing-real-estate",
  "/listing-real-estate-map",
];

const HeroSearchForm2MobileFactory = () => {
  const pathname = useLocation().pathname;
  if (PAGES_REAL_ESTATE.includes(pathname as PathName)) {
    return <FilterFormMobile />;
  }
  // return <HeroSearchForm2Mobile />;
  return <></>
};

export default HeroSearchForm2MobileFactory;
